<script setup lang="ts">
import { T } from '@tolgee/vue'
import SparkIcon from '@/components/icons/SparkIcon.vue'
import { useDailyUpChallenge } from '@/composables/game/challenges'

const { counterToNextDay, formattedCountdown, dailyUpChallenge } = useDailyUpChallenge()
</script>

<template>
  <div
    v-if="dailyUpChallenge"
    class="flex flex-col items-center justify-center"
  >
    <div class="daily-up-button blue-gradient-background relative flex items-center justify-center size-12 rounded-[15px] p-0.5">
      <div class="absolute top-1/2 left-1/2 size-8 red-blur rounded-full -translate-y-1/2 -translate-x-1/2 z-[1]" />
      <SparkIcon class="absolute sparkling-star h-4 w-4 z-[10]" />
      <img
        class="size-10 object-cover z-[3]"
        src="@/assets/images/gifs/trophy.gif"
      >
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div class="z-[1] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-tropee-black">
        <T
          key-name="daily_up_challenge.button"
          default-value="Daily up"
        />
      </div>
      <div
        class="z-[2] -mt-1 whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="counterToNextDay < (3600 * 3) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formattedCountdown }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.sparkling-star {
	top: 4px;
	right: 4px;
	animation: sparkle 2.5s infinite;
	transition: all;
	transition-delay: 200ms;
}

@keyframes sparkle {
	0% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 1;
	}
	20% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 0;
	}
	35% {
		top: auto;
		right: auto;
		bottom: 4px;
		left: 4px;
		opacity: 0;
	}
	50% {
		top: auto;
		right: auto;
		bottom: 4px;
		left: 4px;
		opacity: 1;
	}
	70% {
		top: auto;
		right: auto;
		bottom: 4px;
		left: 4px;
		opacity: 0;
	}
	85% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 0;
	}
	100% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 1;
	}
}

.blue-gradient-background {
	background: linear-gradient(180deg, #FF9D0A 0.01%, #4E5EB8 16.5%, #000 42.5%)
}

.red-blur {
	background: rgba(231, 46, 109, 0.68);
	filter: blur(9px);
}

.daily-up-button::before {
	background: linear-gradient(
		to bottom,
		rgba(255, 255, 255, 0.4) 0%,
		rgba(255, 255, 255, 1) 50%,
		rgba(255, 255, 255, 0.4) 100%
	);
	border-radius: 15px;
	content: "";
	inset: 0;
	-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
	-webkit-mask-composite: xor;
	mask-composite: exclude;
	padding: 2px; /* this is the border width */
	position: absolute;
	z-index: 10;
	pointer-events: none;
}
</style>